import clsx from "clsx";

import { Box, IconButton, Typography } from "@mui/material";
import { Tooltip } from "@shared/Tooltip";
import { useIsClipped } from "@shared/useIsClipped";

import { useStyles } from "./Tag.style";

export interface Props {
    item: API.Tag;
    onClick?: (tag: API.Tag) => void;
    theme?: "dark" | "light";
}
export const Tag = (props: Props) => {
    const { classes } = useStyles(props);
    const { ref: keyRef, clipped: isKeyClipped } = useIsClipped(props.item?.key);
    const { ref: valueRef, clipped: isValueClipped } = useIsClipped(props.item?.value);

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.item);
        }
    };

    const isWrongTab = !props.item?.key || (props.item?.type === "scoped" && !props.item.value);

    if (isWrongTab) {
        return null;
    }

    return (
        <Tooltip
            placement="top"
            title={props.item.value ? `${props.item.key}: ${props.item.value}` : props.item.key}
            hide={!isKeyClipped && !isValueClipped}
            disableChildrenWrapper
        >
            <Box className={classes.container} onClick={onClick}>
                <Box className={classes.keyBox}>
                    <Typography variant="caption" className={classes.label} ref={keyRef}>
                        {props.item.key}
                    </Typography>
                </Box>
                {props.item.value ? (
                    <Box className={classes.valueBox}>
                        <Typography variant="caption" className={classes.label} ref={valueRef}>
                            {props.item.value}
                        </Typography>
                    </Box>
                ) : null}
                {props.onClick ? (
                    <IconButton className={classes.button} onClick={onClick} size="large">
                        <i className={clsx("fa-solid fa-xmark", classes.icon)} />
                    </IconButton>
                ) : null}
            </Box>
        </Tooltip>
    );
};
